/**
 * Subschools for a foundation school
 *
 */

import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { useApi2 } from 'containers/Api2/index.js';
import { FormattedMessage } from 'react-intl';
import { idValues } from 'utils/arrays.js';
import Spinner from 'components/Spinner/index.jsx';
import messages from './messages.js';
import ColorSpan from '../../layout/ColorSpan.js';

function Subschools() {
  const subschools = useApi2({ url: 'sa/subschools', version: 2, ignore: [404] });
  function getBody() {
    if (subschools.loading) {
      return <Spinner />;
    }
    const schools = idValues(subschools);
    return (
      <>
        <p className="form-text"><FormattedMessage {...messages.subschoolsIntro} values={{ count: schools.length }} /></p>
        {schools.length > 0 && (
          <ListGroup>
            {schools.map((school) => (
              <ListGroup.Item key={school.id} className="d-flex px-0">
                <ColorSpan className="flex-grow-1" color={school.theme.themeColor.hex}>{school.name}</ColorSpan>
                <span>{school.city}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </>
    );
  }
  return (
    <Card>
      <Card.Body>
        <h2 className="card-title mb-4"><FormattedMessage {...messages.schools} /></h2>
        {getBody()}
      </Card.Body>
    </Card>
  );
}

export default Subschools;
